"use strict";

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

var objToString = Object.prototype.toString,
    isFunctionStringTag = RegExp.prototype.test.bind(/^[object [A-Za-z0-9]*Function]$/);

module.exports = function (value) {
  return typeof value === "function" && isFunctionStringTag(objToString.call(value));
};